export default __webpack_public_path__ + "static/media/GB.b89f53b0.svg";